import React from "react";
import TrashIcon from "@/assets/icons/trash.svg?react";
import { Button } from "../ui/button";

interface EntityCardProps {
  isEditing: boolean;
  summary: React.ReactNode;
  form: React.ReactNode;
  onEdit?: () => void;
  onSave: () => void;
  onCancel?: () => void;
  canSave?: boolean;
  onRemove?: () => void;
}

export const EntityCard: React.FC<EntityCardProps> = ({
  isEditing,
  summary,
  form,
  onEdit,
  onSave,
  onCancel,
  canSave = true,
  onRemove,
}) => (
  <div className="flex flex-row items-center gap-2">
    <div className="flex flex-1 rounded-lg bg-gray-50 p-4">
      {isEditing ? (
        <div className="flex w-full flex-col gap-4">
          {form}
          <div className="flex flex-row justify-center gap-2">
            {onCancel && (
              <Button variant="secondary" onClick={onCancel}>
                Annuler
              </Button>
            )}
            <Button onClick={onSave} disabled={!canSave} className="w-40">
              Enregistrer
            </Button>
          </div>
        </div>
      ) : (
        <div className="flex w-full flex-row justify-between">
          <div>{summary}</div>
          {onEdit && (
            <button
              onClick={onEdit}
              className="h-12 self-center rounded-lg bg-gray-600 px-3 py-2 text-xs text-white sm:text-sm"
            >
              Modifier
            </button>
          )}
        </div>
      )}
    </div>
    {!isEditing && onRemove && (
      <TrashIcon className="cursor-pointer text-gray-600" onClick={onRemove} />
    )}
  </div>
);
